import { render, staticRenderFns } from "./StockLayout.vue?vue&type=template&id=af699f98&scoped=true&"
import script from "./StockLayout.vue?vue&type=script&lang=js&"
export * from "./StockLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af699f98",
  null
  
)

export default component.exports